import { CALCULATOR_ENDPOINTS } from '@app/configs/api/calculator';
import { baseApi } from './baseApi';
export const calculatorApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCalculatorOffering: builder.query({
            query: () => ({
                url: CALCULATOR_ENDPOINTS.offering,
            }),
            transformResponse: (response) => response.loanOfferings,
        }),
        getCalculations: builder.query({
            query: ({ amount, period }) => ({
                url: CALCULATOR_ENDPOINTS.calculate,
                params: { amount, period },
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetCalculatorOfferingQuery, useGetCalculationsQuery } = calculatorApi;
